import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
import Helpers from '@/util/Helpers';
import { SET_PERMISSAO } from '@/store/mutations';

Vue.use(Router);

var router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            props: true,
            component: Login,
            meta: { icon: '', description: 'Login' }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/Home.vue'),            
            meta: { icon: 'home', description: 'Home', requiresAuth: true, grantAll: true },
            redirect: { name: 'principal' },            
            children: [
                {
                    path: '/principal',
                    name: 'principal',
                    component: () => import('@/views/Principal.vue'),
                    meta: { icon: 'home', description: 'Home', requiresAuth: true, grantAll: true },
                },
                {
                    path: '/usuario',
                    name: 'usuario',
                    component: () => import('@/views/Usuario.vue'),
                    meta: { icon: 'user', description: 'Gerenciamento de Usuários', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/credencias',
                    name: 'credencias',
                    component: () => import('@/views/Credencias.vue'),
                    meta: { icon: 'tag', description: 'Gerenciamento de Credencias', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/credenciasInternas',
                    name: 'credenciasInternas',
                    component: () => import('@/views/CredenciasInternas.vue'),
                    meta: { icon: 'tag', description: 'Gerenciamento de Credencias', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/fontesMonitoradas',
                    name: 'fontesMonitoradas',
                    component: () => import('@/views/Relatorios/FontesMonitoradas.vue'),
                    meta: { icon: 'printer', description: 'Fontes Monitoradas', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/controleFontes',
                    name: 'controleFontes',
                    component: () => import('@/views/Relatorios/ControleFontes.vue'),
                    meta: { icon: 'printer', description: 'Controle de Fontes', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/resumoAlertas',
                    name: 'resumoAlertas',
                    component: () => import('@/views/Relatorios/ResumoAlertas.vue'),
                    meta: { icon: 'printer', description: 'Relatório de Alertas', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/relatorioProcessos',
                    name: 'relatorioProcessos',
                    component: () => import('@/views/Relatorios/RelatorioProcessos.vue'),
                    meta: { icon: 'printer', description: 'Relatório de Processos', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/controlePrioridadeJusBr',
                    name: 'controlePrioridadeJusBr',
                    component: () => import('@/views/ControlePrioridadeJusBr.vue'),
                    meta: { icon: 'tag', description: 'Controle de Prioridade Jus BR', requiresAuth: true, grantAll: false },
                },
                {
                    path: '/resumoAlertasJusBr',
                    name: 'resumoAlertasJusBr',
                    component: () => import('@/views/Relatorios/ResumoAlertasJusBr.vue'),
                    meta: { icon: 'printer', description: 'Relatório de Alertas JusBr', requiresAuth: true, grantAll: false },
                },
            ],
        },
    ],
});
router.beforeEach((to, from, next) => {
    var userPerfilPortal = router.app.$store.state.auth.idPerfilPortal;
    if (to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.state.auth.token || router.app.$store.state.auth.token === 'null')) {

        next({
            path: '/',
            query: { redirect: to.fullPath }
        });
    } else {        
        if (to.meta.grantAll == false) {
            let listGrants = [];
            listGrants = Helpers.buscarPerfilPortalTela(to.name);
            if (listGrants.includes(userPerfilPortal)) {
                next();
            } else {
                router.app.$store.commit(SET_PERMISSAO, { user_no_permission: { temPermissao: false } });
                next({
                    name: 'home',
                    query: { redirect: to.fullPath }
                });
            }
        } else {
            next();
        }
    }
});

export default router;